export default {
    methods: {
        //yyyy/mm/dd -> mm/dd/yyyy
        formatDate(dateStr) {
            const [year, month, day] = dateStr.split("-");

            return `${month}/${day}/${year}`;
        },

        formatIsoDate(isoDateStr) {
            const dateObj = new Date(isoDateStr)
            const datePart = dateObj.toISOString().slice(0, 10)
            const timePart = dateObj.toTimeString().slice(0, 8)
            return {date: datePart, time: timePart}
        },

        formatIsoDateString(isoDateStr) {
            const {date, time} = this.formatIsoDate(isoDateStr)
            return `${date}\n${time}`
        }

    }
}
